/*
 * @Author: centerm.gaohan 
 * @Date: 2020-10-12 16:09:22 
 * @Last Modified by: centerm.gaohan
 * @Last Modified time: 2020-11-03 14:21:58
 */
import React, { useEffect, useState } from 'react';
import { Toast, Button, List, InputItem, Picker, Icon, TextareaItem } from 'antd-mobile';
import { useHistory } from 'react-router-dom'
import { api } from '../../../../common/app';
import "./register.css";
import { FormEducation } from './compoents/form-education'
import { FormCheckbox } from './compoents/form-checkbox'
import { AutoComplete } from 'antd';
import { merge } from 'lodash';
import FormMobile from './compoents/form-mobile'
import {
  RenderSelect,
  RenderInput,
  RenderHospital,
  RenderTextArea,
  RenderArea,
  RenderSubject,
  RenderTechnical,
  RenderEducation,
} from "./compoents/render";
import { useUserStatus } from '../../../../common/hooks/user-status';
const Item = List.Item;

export default (props: any) => {
  const history = useHistory();
  const meetid = props.match.params.id;
  const { modelstatus } = useUserStatus(meetid);

  // 会议总览
  const [meetIndex, setMeetIndex] = useState({} as any);
  // 用户已经存在的信息
  const [detail, setDetail] = useState({} as any);

  const [forms, setForms] = useState([] as any[]);
  // 地区区号 
  const [areaCode, setAreaCode] = useState([] as any[]);
  // 用户选择的地区区号
  const [selectedArea, setSelectedArea] = useState('86');
  // 验证码
  const [verifyCode, setVerifyCode] = useState('86');
  // 手机号码
  const [mobile, setMobile] = useState('');

  // loading
  const [loading, setLoading] = useState(false);

  // 初始化一下数据源吧
  const [formFormatItems, setFormFormatItems] = useState({} as any);

  const [dataFromTable, setDataFromTable] = useState(false);

  useEffect(() => {
    window.addEventListener("focusout", () => {
      window.scrollTo(0, window.scrollY + 1);
    });
    return () => window.addEventListener("focusout", () => {
      window.scrollTo(0, window.scrollY + 1);
    });
  }, []);

  // 获取会议总览
  useEffect(() => {
    if (!!meetid) {
      (api as any).getMeetingIndex(meetid)
        .then(async (result: any) => {
          setMeetIndex(result.result);
        }).catch((error: any) => {
          Toast.fail(error.message);
        });
    }
  }, [meetid])

  // 获取会议表单注册条目
  useEffect(() => {
    if (!!meetid) {
      (api as any).getMeetRegister({ meetid })
        .then(async (result: any) => {
          const responseForms: any[] = merge([], result.result);
          setForms(responseForms);

          // 重新试试
          let formatItems: any = {};
          responseForms.forEach((item) => {

            if (item.en_name === 'hospital') {
              formatItems[item.en_name] = '';
              formatItems.type_hospital_area_info = ''
              formatItems.type_hospital_province_code = '';
              formatItems.type_hospital_city_code = '';
              formatItems.type_hospital_area_code = '';
            } else if (item._en_name === 'area') {
              formatItems[item.en_name] = [];
              formatItems.type_area_area_info = '';
            } else {
              formatItems[item.en_name] = ''
            }

          });
          setFormFormatItems(formatItems);
        }).catch((error: any) => {
          Toast.fail(error.message);
        });
    }
  }, [meetid]);

  useEffect(() => {
    if (forms.length > 0) {
      (api as any).getUserinfo({ meetid })
        .then((userinfoResult: any) => {
          if (userinfoResult && userinfoResult.result?.data) {
            const userinfo = merge({}, userinfoResult.result.data);
            setDetail(userinfo);
          }
        });

      (api as any).getUserAreaCode({ meetid })
        .then((result: any) => {
          if (result && result.code === 200) {
            setSelectedArea(result.result.area_code);
          }
        });
    }
  }, [forms]);

  useEffect(() => {
    if (detail) {
      const userinfo = detail;
      let nextFormItems: any = merge({}, formFormatItems)
      Object.keys(userinfo).forEach(key => {

        if (key === 'hospital') {
          nextFormItems[key] = userinfo[key] || '';
          nextFormItems.type_hospital_area_info = userinfo.type_hospital_area_info;
          nextFormItems.type_hospital_province_code = userinfo.type_hospital_province_code;
          nextFormItems.type_hospital_city_code = userinfo.type_hospital_city_code;
          nextFormItems.type_hospital_area_code = userinfo.type_hospital_area_code;
        } else if (key === "type_area_province_code") {
          nextFormItems.area = [
            userinfo.type_area_province_code,
            userinfo.type_area_city_code,
            userinfo.type_area_area_code
          ];
          nextFormItems.type_area_area_info = userinfo.type_area_area_info;
        } else {
          nextFormItems[key] = userinfo[key];
        }
        if (key === 'mobile') {
          setMobile(userinfo[key])
        }
      })

      setFormFormatItems(nextFormItems);
    }

  }, [detail]);


  useEffect(() => {
    if (detail) {
      const userinfo = detail;

      const nextForms = forms;

      Object.keys(userinfo).forEach(key => {
        const currentIndex = nextForms.findIndex((f: any) => f.en_name === key);
        if (currentIndex > -1) {
          nextForms[currentIndex].value = userinfo[key];
        }
      })
      console.log('nextForms', nextForms);
      setForms(nextForms);
    }

  }, [detail]);

  // 获取地区区号
  useEffect(() => {
    if (!!meetid) {
      (api as any).getAreaCode({ meetid })
        .then((result: any) => {
          setAreaCode(result.result.map((item: any) => {
            return { value: item.area_code, label: item.zh + "(" + item.area_code_show + ")" }
          }));
        }).catch((error: any) => {
          Toast.fail(error.message);
        });
    }
  }, [meetid]);

  const chagneFormatValue = (item: any, value: any) => {
    setFormFormatItems((prevForms: any) => {
      return {
        ...prevForms,
        [item.en_name]: value,
      };
    })
  }

  const changeFormValue = (value: any, item: any) => {
    setForms(prevForms => {
      const currentFormIndex = prevForms.findIndex(f => f.type === item.type && f.en_name === item.en_name);
      let currentForm = merge({}, prevForms[currentFormIndex]);
      currentForm.value = value;
      prevForms[currentFormIndex] = currentForm;
      return prevForms;
    })
  }

  const getUnUserinfo = (mobile: string) => {
    (api as any)
      .getUnUserInfo({ meetid: meetid, mobile })
      .then((response: any) => {
        console.log("response", response);
        if (response.code === 200 && response.result.data) {
          setDetail(response.result.data);
          setDataFromTable(true)
        }
      })
      .catch((error: any) => {
        Toast.fail(error.message);
      });
  }

  // 发送验证码
  const sendVerificationCode = (callback?: any) => {
    console.log('callback', callback);
    if (!mobile) {
      Toast.fail('请输入手机号');
      return;
    }
    console.log('callback', callback);
    callback();
    console.log('mobile', mobile);
    (api as any).sendVerificationCode({
      mobile: mobile?.replace(/\s/g, "") || '',
      area_code: selectedArea,
    })
      .then(() => {
        Toast.success('已发送手机验证码');
        getUnUserinfo(mobile?.replace(/\s/g, "") || "");
      }).catch((error: any) => {
        Toast.fail(error.message);
      })
  }

  // 提交
  const submit = () => {
    try {
      let payload: any[] = [];
      console.log('formFormatItems', formFormatItems);
      forms.forEach((item) => {
        if (item.en_name === 'mobile') {
          payload.push({ name: item.en_name, value: mobile?.replace(/\s/g, "") || '' });
        } else if (item.en_name === 'hospital') {
          payload.push({
            name: 'hospital',
            value: formFormatItems[item.en_name],
          });
          payload.push({
            name: "type_hospital_area_info",
            value: [
              formFormatItems.type_hospital_province_code,
              formFormatItems.type_hospital_city_code,
              formFormatItems.type_hospital_area_code,
            ],
          });
          payload.push({
            name: 'type_hospital_province_code',
            value: formFormatItems.type_hospital_province_code
          });
          payload.push({
            name: 'type_hospital_city_code',
            value: formFormatItems.type_hospital_city_code
          })
          payload.push({
            name: 'type_hospital_area_code',
            value: formFormatItems.type_hospital_area_code
          })
        } else if (item.en_name === 'area') {
          payload.push({
            name: 'type_area_province_code',
            value: formFormatItems.area[0]
          });
          payload.push({
            name: 'type_area_city_code',
            value: formFormatItems.area[1]
          })
          payload.push({
            name: 'type_area_area_code',
            value: formFormatItems.area[2]
          })
          payload.push({
            name: "type_area_area_info",
            value: formFormatItems.area,
          });
          payload.push({
            name: "area",
            value: formFormatItems.type_area_area_info,
          });
        } else {
          payload.push({
            name: item.en_name,
            value: formFormatItems[item.en_name],
          });
        }
      });
      payload.push({
        name: "code",
        value: verifyCode,
      });
      payload.push({
        name: "area_code",
        value: selectedArea || "",
      });
      const isMine = window.location.href.indexOf('/mine/') > -1;
      console.log('payload', payload);
      // return;
      setLoading(true);
      // 还差 省市区 学科 学历
      (api as any).formRegisterSubmit({
        meetid,
        data: JSON.stringify(payload)
      })
        .then((result: any) => {
          if (result.code === 200) {
            Toast.success(`${isMine ? '更新' : '注册'}成功！`);
            // 跳转

            setTimeout(() => {
              setLoading(false);
              if (isMine) {
                history.goBack();
                return;
              }

              (api as any).showButton({ meetid })
                .then((result: any) => {
                  // console.log('result', result);
                  if (result.code !== 200) {
                    return;
                  }

                  // 会议开启了行程
                  if (!!result.result.is_travel && modelstatus.journey.status === true) {
                    history.replace(`/home/joruney/${meetid}`);
                    return;
                  }
                  // 会议开启了酒店
                  if (!!result.result.is_hotel && modelstatus.hotel.status === true) {
                    history.replace(`/home/hotel/${meetid}`);
                    return;
                  }
                  // 会议开启了接送机
                  if (!!result.result.is_plain && modelstatus.plain.status === true) {
                    history.replace(`/home/plain/${meetid}`);
                    return;
                  }
                  history.replace(`/home/index/${meetid}`);
                }).catch((err: any) => {
                  console.log('err', err);
                  setLoading(false);
                });
            }, 1000);
          }
          Toast.fail(result.message, 1);
          setLoading(false);
        }).catch((error: any) => {
          Toast.fail(error.message, 1);
          setLoading(false);
        })
    } catch (error) {
      Toast.fail(error.message, 1);
      setLoading(false);
    }
  }

  const renderCheckBox = (value: any) => {
    return (
      <FormCheckbox
        title={value.zh_name}
        xing={value.is_required ? "*" : ""}
        check={JSON.parse(value.check)}
        value={value.value}
        onChange={(arr) => {
          let str = [];
          for (let index of arr) {
            if (index.isCheck) {
              str.push(index.label);
            }
          }
          changeFormValue(JSON.stringify(str), value);
        }}
      />
    )
  }
  return (
    <div>
      <img src={meetIndex?.cover} style={{ width: "100%", height: "211px" }} alt="" />
      <div className="regBox">
        <div style={{ padding: 12 }}>
          <List style={{ backgroundColor: "white", flexBasis: "initial" }}>
            {forms.map((item, index) => {
              switch (item.type) {
                case 'input': {

                  if (item.en_name === "mobile") {
                    return (
                      <FormMobile
                        mobileValue={mobile}
                        value={item}
                        selectedArea={selectedArea}
                        setSelectedArea={setSelectedArea}
                        areaCode={areaCode}
                        setVerifyCode={setVerifyCode}
                        sendVerificationCode={sendVerificationCode}
                        onMobileChange={(text: any) => setMobile(text)}
                        isEdit={!!detail.id && dataFromTable === false}
                      />
                    );
                  }
                  return (
                    <div key={index}>
                      {/* {renderInput(item)} */}
                      <RenderInput
                        {...(item.en_name === "username" &&
                          (!!detail.id &&
                            dataFromTable === false)
                          ? { disabled: true }
                          : {})}
                        item={item}
                        value={formFormatItems[item.en_name] || ""}
                        onChange={chagneFormatValue}
                      />
                    </div>
                  );
                }
                case 'select': {
                  return (
                    <div key={index}>
                      <RenderSelect
                        item={item}
                        value={formFormatItems[item.en_name] || ''}
                        onChange={chagneFormatValue}
                      />
                      {/* {renderSelect(item)} */}
                    </div>
                  )
                }
                case 'radio': {
                  return (
                    <RenderSelect
                      item={item}
                      value={formFormatItems[item.en_name] || ''}
                      onChange={chagneFormatValue}
                    />
                  )
                }
                case "textArea": {
                  return (
                    <RenderTextArea
                      key={index}
                      item={item}
                      value={formFormatItems[item.en_name] || ''}
                      onChange={chagneFormatValue}
                    />
                  )
                }
                case "checkBox":
                  return (
                    <div key={index}>
                      {renderCheckBox(item)}
                    </div>
                  )

                case 'hospital':
                  return (
                    <RenderHospital
                      key={index}
                      item={item}
                      pickerValue={[
                        formFormatItems.type_hospital_province_code,
                        formFormatItems.type_hospital_city_code,
                        formFormatItems.type_hospital_area_code,
                      ]}
                      value={formFormatItems[item.en_name] || ""}
                      meetid={meetid}
                      onChange={chagneFormatValue}
                    />
                  );
                case 'area': {
                  return (
                    <RenderArea
                      extra={formFormatItems[item.en_name]}
                      key={index}
                      item={item}
                      value={formFormatItems[item.en_name] || []}
                      meetid={meetid}
                      onChange={chagneFormatValue}
                    />
                  );
                }
                case 'subject': {
                  return (
                    <RenderSubject
                      extra={formFormatItems[item.en_name]}
                      key={index}
                      item={item}
                      value={formFormatItems[item.en_name] ? formFormatItems[item.en_name].map((i: any) => Number(i)) : []}
                      meetid={meetid}
                      onChange={chagneFormatValue}
                    />
                  )
                }
                case "technical":
                  return (
                    <RenderTechnical
                      extra={formFormatItems[item.en_name]}
                      key={index}
                      item={item}
                      value={formFormatItems[item.en_name] ? [Number(formFormatItems[item.en_name])] : []}
                      meetid={meetid}
                      onChange={chagneFormatValue}
                    />
                  );
                case "education":
                  return (
                    <RenderEducation
                      extra={formFormatItems[item.en_name]}
                      key={index}
                      item={item}
                      value={formFormatItems[item.en_name] ? [Number(formFormatItems[item.en_name])] : []}
                      meetid={meetid}
                      onChange={chagneFormatValue}
                    />
                  );
              }
            })}
          </List>
          <div style={{ padding: 10 }} />
          <Button
            type={"primary"}
            size={"large"}
            onClick={submit}
            loading={loading}
          >
            {!!detail.id ? '更新' : '提交'}
          </Button>
        </div>
      </div>
    </div>
  )
}